<div class="payment-method-wrapper d-flex flex-column">
<!--  A form label must be associated with a control and have accessible text-->
  <div class="payment-method p-3 d-flex align-items-center gap-3" (click)="onSelectPaymentMethod(paymentMethodInfo.paymentMode)" (keydown)="handleDropdownKey($event)">
    <img [src]="'assets/images/'+paymentMethodInfo.icon" alt="paymentMethodInfo.label" />
    <div class="d-flex flex-column">
    <span>{{ paymentMethodInfo.label}}</span>
    </div>
  </div>
  <div *ngIf="isSelected" class="cheque-details d-flex gap-4 flex-column">
    <div class="d-flex flex-column flex-xl-row cheque-information-container gap-4">
      <div class="cheque-information d-flex flex-column gap-3 flex-grow-1">
          <div class="form-group">
            <label for="input-cheque-order-number" class="col-form-label">Cheque/Cashier's Order Number <span style="color: red;">*</span></label>
            <input
              id="input-cheque-order-number"
              class="form-control form-control-md vkeyboard"
              type="text"
              spellcheck="false"
              [(ngModel)]="chequeDetails.chequeNumber"
              #chequeInput="ngModel"
              pattern="^\d{1,20}$"
              required
              name="chequeNumber"
              placeholder="Enter up to 20-digit Cheque Number"
              autocomplete="off"
              (input)="chequeInput.control.markAsTouched()"
              [ngClass]="{'is-invalid': chequeInput.invalid && chequeInput.touched}"
              (keypress)="allowOnlyNumbers($event)"
            />
            <div *ngIf="chequeInput.touched && chequeInput.invalid" class="text-danger mt-1">
              <small *ngIf="chequeInput.errors?.['required']"><span class="error-icon">–</span> Cheque number is required.</small>
              <small *ngIf="chequeInput.errors?.['pattern']"><span class="error-icon">–</span> Cheque Number is allowed up to 20 digits.</small>
            </div>
          </div>
          <div class="form-group">
            <label for="bank-select" class="col-form-label">Bank Name <span style="color: red;">*</span> </label>
            <div class="drop-down">
              <app-drop-down id="bank-select" [dataSource]="bankDatasource" placeholder="Select Bank" (selectedOption)="onBankSelected($event)"></app-drop-down>
            </div>
          </div>
          <div class="form-group">
            <label for="input-cheque-order-amount" class="col-form-label">Cheque/Cashier's Order Amount <span style="color: red;">*</span></label>
            <input
              id="input-cheque-order-amount"
              class="form-control form-control-md vkeyboard"
              type="text"
              spellcheck="false"
              required
              [disabled]="!isInputEnabled"
              [(ngModel)]="enteredChequeAmount"
              (input)="onChequeAmountChange($event)"
              (blur)="onAmountBlur()"
              name="chequeAmount"
              placeholder="Enter Cheque Amount"
              [ngClass]="{'is-invalid': amountZero || messageToShow === 'PAYABLE_EXCEEDED'}"
            />
            <div *ngIf="amountZero || messageToShow === 'PAYABLE_EXCEEDED' || messageToShow === 'LIMIT_EXCEEDED'" class="text-danger mt-1">
              <small *ngIf="amountZero">
                <span class="error-icon">–</span> Amount should be greater than 0.
              </small>
              <small *ngIf="messageToShow === 'PAYABLE_EXCEEDED'">
                <span class="error-icon">–</span> Amount should not exceed {{ showAmountFormatted(pacDetails.balancePayable) }}.
              </small>
              <small *ngIf="messageToShow === 'LIMIT_EXCEEDED'">
                <span class="error-icon">–</span>
                Entered amount exceeded the maximum payable amount {{showAmountFormatted(this.paymentMethodInfo?.totalLimit ?? 0)}}.
              </small>
            </div>
            <div class="form-check">
              <label class="form-check-label" for="CheckboxDefault121">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="CheckboxDefault11"
                  id="CheckboxDefault121"
                  [(ngModel)]="enableAmountCheckbox"
                  (change)="toggleAmountInput($event)"
                />
                <label class="form-check-label" for="CheckboxDefault121">Change Amount</label>
              </label>
            </div>
          </div>
        <div class="p-3 mb-4" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
          <div style="font-weight: bold;" class="mt-0 mb-0">Note: </div>
          <span [innerHTML]="note"></span>
        </div>
        <div *ngIf="enableAmountCheckbox" class="p-3 mb-4 mt-3" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
          <div class="mt-0 mb-0 ">
            Full payment is required. Indicate smaller amount for payment with different payment modes or accounts.
          </div>
        </div>

      </div>

      <div class="cheque-declaration flex-grow-1">
        <h6 class="fw-bold mb-2 text-danger fs-5">Please verify and declare the following instructions:</h6>
        <ol class="ps-3">
          <li>Cheque/Cashier's Order is addressed to "Singapore Courts" or "Registrar, State Courts" or as stipulated in the letter issued by the Court.</li>
          <li>Cheque/Cashier’s Order is valid and not post-dated.</li>
          <li>Cheque/Cashier’s Order is crossed.</li>
          <li>Cheque/Cashier’s Order is not torn or mutilated.</li>
          <li>Payment amounts indicated in words and numbers tally.</li>
          <li>Cheque is duly signed by authorized signatory(ies).</li>
          <li>Cheque amendments (if any) are counter-signed by the same authorized signatory(ies).</li>
          <li>Case number and contact information are indicated at the back of the cheque/Cashier’s Order.</li>
        </ol>

        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="ackCheckbox"
            [(ngModel)]="isAcknowledged"
            [class.disabled]="!isFormValid()"
            [style.pointer-events]="!isFormValid() ? 'none' : 'auto'"
          />
          <label class="form-check-label" for="ackCheckbox">
            I declare the cheque/Cashier’s Order confirms to the above.<br />
            I understand that the payment will be rendered void if the cheque/Cashier’s Order is not honored by the bank due to any reason.<br />
            I declare the above cheque/Cashier’s Order has been deposited into the Singapore Courts cheque deposit box.
          </label>
        </div>
      </div>
    </div>

    <!-- Confirm Button -->
    <button type="button" class="btn btn-primary submit-btn align-self-end" [disabled]="isConfirmDisabled()"  (click)="onSubmit()">
      Confirm
    </button>
  </div>
</div>


